import Vue from "vue";
import Vuex from "vuex";
//import router from './../router'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        user: false,
        offers: [],
        offersLoaded: false,
        pending_players: [],
        players: [],
        playersLoaded: false,
        groups: [],
        activeplayer: false,
        categories: [],
        messages: [],
        messagesLoaded: false,
        sentMessages: [],
        proLessons: [],
        proLessonsLoaded: false,
        dialogueOpen: false,
        dialogueText: "",
        mobNavFix: false,
        unreadMsgCount: 0,
        subscriptions: [],
        advertisements: {
            sponsor: null,
            home_content: null,
        },
    },
    mutations: {
        resetState(state) {
            state.user = false;
            state.offers = [];
            state.offersLoaded = false;
            state.pending_players = [];
            state.players = [];
            state.playersLoaded = false;
            state.groups = [];
            state.activeplayer = false;
            state.categories = [];
            state.messages = [];
            state.messagesLoaded = false;
            state.sentMessages = [];
            state.proLessons = [];
            state.proLessonsLoaded = false;
            state.dialogueOpen = false;
            state.dialogueText = "";
            state.mobNavFix = false;
            state.unreadMsgCount = 0;
            state.subscriptions = [];
            state.advertisements = {
                sponsor: null,
                home_content: null,
            };
        },
        updateUser(state, response) {
            state.user = response;
            window.nsWebViewInterface.emit("setUser", response.id);

            setTimeout(() => {
                this.dispatch("getMsgUnreadCount");
            }, 1000);
        },
        updateUserSettings(state, settings) {
            state.user.settings = settings;
        },
        updateLesson(state, lesson) {
            var index = state.user.lessons.findIndex((item) => {
                return item.id == lesson.id;
            });
            Vue.set(state.user.lessons, index, lesson);
        },
        updateNextLesson(state, lesson) {
            state.user.next_lesson = lesson;
        },
        updateProLesson(state, lesson) {
            var index = state.proLessons.findIndex((item) => {
                return item.id == lesson.id;
            });
            Vue.set(state.proLessons, index, lesson);
        },
        addPlayerLesson(state, lesson) {
            state.user.lessons.push(lesson);
        },
        addYardageItem(state, yardage) {
            state.user.yardages.push(yardage);
        },
        deleteYardageItem(state, yardage) {
            var index = state.user.yardages.findIndex(($item) => {
                return $item.id == yardage.id;
            });

            state.user.yardages.splice(index, 1);
        },
        addBagItem(state, club) {
            state.user.bags.push(club);
        },
        deleteBagItem(state, club) {
            var index = state.user.bags.findIndex(($item) => {
                return $item.id == club.id;
            });

            state.user.bags.splice(index, 1);
        },
        getPendingPlayers(state, players) {
            state.pending_players = players;
        },
        addToPendingPlayers(state, player) {
            state.pending_players.push(player);
        },
        removePendingPlayer(state, player_id) {
            var index = state.pending_players.findIndex(($player) => {
                return $player.id == player_id;
            });
            console.log(index);
            state.pending_players.splice(index, 1);
            console.log(state.pending_players);
        },
        getPlayers(state, players) {
            state.playersLoaded = true;
            state.players = players;
        },
        getPlayer(state, player) {
            Vue.set(state, "activePlayer", player);
        },
        clearActivePlayer(state) {
            Vue.set(state, "activePlayer", false);
        },
        getMessages(state, messages) {
            Vue.set(state, "messages", messages);
        },
        deleteMessage(state, message) {
            var index = state.messages.findIndex(($message) => {
                return $message.id == message.id;
            });
            state.messages.splice(index, 1);
        },
        getSentMessages(state, messages) {
            Vue.set(state, "sentMessages", messages);
            state.messagesLoaded = true;
        },
        addSentMessage(state, message) {
            state.sentMessages.push(message);
        },
        getGroups(state, groups) {
            Vue.set(state, "groups", groups);
        },
        addGroup(state, group) {
            state.groups.push(group);
        },
        removeGroup(state, group) {
            var index = state.groups.findIndex(($group) => {
                return $group.id == group.id;
            });
            state.groups.splice(index, 1);
        },
        getCategories(state, categories) {
            state.categories = categories;
        },
        addCategory(state, category) {
            state.categories.push(category);
        },
        removeCategory(state, category) {
            var index = state.categories.findIndex(($category) => {
                return $category.id == category.id;
            });
            state.categories.splice(index, 1);
        },
        getOffers(state, offers) {
            state.offers = offers;
            state.offersLoaded = true;
        },
        deleteOffer(state, offer) {
            var index = state.offers.findIndex(($offer) => {
                return $offer.id == offer.id;
            });
            state.offers.splice(index, 1);
        },
        addOffer(state, offer) {
            state.offers.push(offer);
        },
        updateOffer(state, offer) {
            var index = state.offers.findIndex(($offer) => {
                return $offer.id == offer.id;
            });

            state.offers.splice(index, 1, offer);
        },
        getProLessons(state, lessons) {
            state.proLessons = lessons;
            state.proLessonsLoaded = true;
        },
        addCreditToUser(state, credit) {
            state.user.credits = credit;
        },
        getMsgUnreadCount(state, msgCount) {
            state.unreadMsgCount = msgCount;
        },
        getUserCredits(state, credits) {
            console.log("getting credits");
            state.user.credits = credits;
        },
        getAdvertisements(state, advertisements) {
            state.advertisements = advertisements;
        },
    },
    actions: {
        getUser(context) {
            window.axios.get("/user").then((response) => {
                context.commit("updateUser", response.data);
            });
        },
        updateUser(context, user) {
            context.commit("updateUser", user);
        },
        updateUserSettings(context, settings) {
            context.commit("updateUserSettings", settings);
        },
        updateLesson(context, lesson) {
            context.commit("updateLesson", lesson);
        },
        updateNextLesson(context, lesson) {
            context.commit("updateNextLesson", lesson);
        },
        updateProLesson(context, lesson) {
            context.commit("updateProLesson", lesson);
        },
        addPlayerLesson(context, lesson) {
            context.commit("addPlayerLesson", lesson);
        },
        addYardageItem(context, yardage) {
            context.commit("addYardageItem", yardage);
        },
        deleteYardageItem(context, yardage) {
            context.commit("deleteYardageItem", yardage);
        },
        addBagItem(context, club) {
            context.commit("addBagItem", club);
        },
        deleteBagItem(context, club) {
            context.commit("deleteBagItem", club);
        },
        getPendingPlayers(context) {
            window.axios.get("/pending_player").then((response) => {
                context.commit("getPendingPlayers", response.data);
            });
        },
        addToPendingPlayers(context, player) {
            context.commit("addToPendingPlayers", player);
        },
        removePendingPlayer(context, player_id) {
            context.commit("removePendingPlayer", player_id);
        },
        getPlayers(context) {
            window.axios.get("/player").then((response) => {
                context.commit("getPlayers", response.data);
            });
        },
        getPlayer(context, player_id) {
            window.axios.get("/player/" + player_id).then((response) => {
                context.commit("getPlayer", response.data);
            });
        },
        clearActivePlayer(context) {
            context.commit("clearActivePlayer");
        },
        getMessages(context) {
            window.axios.get("/message").then((response) => {
                context.commit("getMessages", response.data);
            });
        },
        deleteMessage(context, message) {
            window.axios.delete("/message/" + message.id).then(() => {
                context.commit("deleteMessage", message);
            });
        },
        getSentMessages(context) {
            window.axios.get("/message?sent=true").then((response) => {
                context.commit("getSentMessages", response.data);
            });
        },
        addSentMessage(context, message) {
            context.commit("addSentMessage", message);
        },
        getGroups(context, groups) {
            context.commit("getGroups", groups);
        },
        addGroup(context, group) {
            context.commit("addGroup", group);
        },
        removeGroup(context, group) {
            window.axios.delete("/group/" + group.id).then(() => {
                context.commit("removeGroup", group);
            });
        },
        getCategories(context) {
            window.axios.get("/category").then((response) => {
                context.commit("getCategories", response.data);
            });
        },
        addCategory(context, category) {
            context.commit("addCategory", category);
        },
        removeCategory(context, category) {
            context.commit("removeCategory", category);
        },
        getOffers(context) {
            window.axios.get("/offer").then((response) => {
                context.commit("getOffers", response.data);
            });
        },
        deleteOffer(context, offer) {
            context.commit("deleteOffer", offer);
        },
        addOffer(context, offer) {
            context.commit("addOffer", offer);
        },
        updateOffer(context, offer) {
            context.commit("updateOffer", offer);
        },
        getProLessons(context) {
            window.axios.get("/lesson").then((response) => {
                context.commit("getProLessons", response.data);
            });
        },
        addCreditToUser(context, credit) {
            context.commit("addCreditToUser", credit);
        },
        getMsgUnreadCount(context) {
            window.axios.get("/unread-count").then((response) => {
                context.commit("getMsgUnreadCount", response.data);
            });
        },
        resetState(context) {
            context.commit("resetState");
        },
        getUserCredits(context) {
            window.axios.get("/credits").then((response) => {
                context.commit("getUserCredits", response.data);
            });
        },
        getAdvertisements(context) {
            window.axios.get("/advertisements/active").then((response) => {
                context.commit("getAdvertisements", response.data);
            });
        },
    },
});
